// Topic-specific social cards for the 66 reviewed landing pages.
// Keep clinical/editorial artwork distinct from patient-result galleries.
export const SOCIAL_IMAGE_ASSETS = {
  "aligners": {
    "url": "https://media.base44.com/images/public/697e88817b05b4051a928e3f/dc36148cf_aligners.png",
    "alt": "Clear aligner trays and a dental model — Explore Clear Aligners, Trinity Dental Arts",
    "width": 1734,
    "height": 907
  },
  "urgent": {
    "url": "https://media.base44.com/images/public/697e88817b05b4051a928e3f/a0d40bcb6_urgent.png",
    "alt": "An examination chair and dental mirror for urgent dental care — Trinity Dental Arts",
    "width": 1734,
    "height": 907
  },
  "comfort": {
    "url": "https://media.base44.com/images/public/697e88817b05b4051a928e3f/aeb208fa3_comfort.png",
    "alt": "A calm dental setting illustrating comfort and sedation options — Trinity Dental Arts",
    "width": 1734,
    "height": 907
  },
  "tmj": {
    "url": "https://media.base44.com/images/public/697e88817b05b4051a928e3f/902ebb150_tmj.png",
    "alt": "A clinical jaw model illustrating jaw and TMJ evaluation — Trinity Dental Arts",
    "width": 1733,
    "height": 907
  },
  "sleep": {
    "url": "https://media.base44.com/images/public/697e88817b05b4051a928e3f/9b4237018_sleep.png",
    "alt": "A dental oral appliance illustrating dental sleep medicine — Trinity Dental Arts",
    "width": 1734,
    "height": 907
  },
  "implants": {
    "url": "https://media.base44.com/images/public/697e88817b05b4051a928e3f/a6ed94da3_implants.png",
    "alt": "A full-arch implant teaching model — Explore Dental Implants, Trinity Dental Arts",
    "width": 1734,
    "height": 907
  },
  "comparison": {
    "url": "https://media.base44.com/images/public/697e88817b05b4051a928e3f/cc5bc1208_comparison.png",
    "alt": "Fixed implant and removable denture teaching models — Compare Tooth Replacement Options, Trinity Dental Arts",
    "width": 1734,
    "height": 907
  },
  "investment": {
    "url": "https://media.base44.com/images/public/697e88817b05b4051a928e3f/1a3f57350_investment.png",
    "alt": "A treatment-planning desk with a dental model and calculator — Plan Your Dental Investment, Trinity Dental Arts",
    "width": 1734,
    "height": 907
  },
  "cosmetic": {
    "url": "https://media.base44.com/images/public/697e88817b05b4051a928e3f/873b35155_cosmetic.png",
    "alt": "Porcelain veneers, a shade guide and a dental model — A Smile Plan Made for You, Trinity Dental Arts",
    "width": 1733,
    "height": 907
  },
  "routine": {
    "url": "https://media.base44.com/images/public/697e88817b05b4051a928e3f/18c64a6b3_routine.png",
    "alt": "A dental mirror, toothbrush and teaching model — Everyday Dental Care, Trinity Dental Arts",
    "width": 1732,
    "height": 908
  },
  "education": {
    "url": "https://media.base44.com/images/public/697e88817b05b4051a928e3f/ded7cd0eb_education.png",
    "alt": "A dental teaching model and open research journal — Clear Answers, Informed Choices, Trinity Dental Arts",
    "width": 1731,
    "height": 908
  },
  "whitening": {
    "url": "https://media.base44.com/images/public/697e88817b05b4051a928e3f/8bb2d7f09_whitening.png",
    "alt": "A clinical shade guide and whitening tray — Explore a Brighter Smile, Trinity Dental Arts",
    "width": 1733,
    "height": 907
  },
  "consult": {
    "url": "https://media.base44.com/images/public/697e88817b05b4051a928e3f/349a7532d_consult.png",
    "alt": "A consultation planner and dental model — Your Next Step Starts Here, Trinity Dental Arts",
    "width": 1734,
    "height": 907
  },
  "arch-options": {
    "url": "https://media.base44.com/images/public/697e88817b05b4051a928e3f/8ae553ad4_arch-options.png",
    "alt": "Two neutral dental arch models — All-on-4 or All-on-6? An individual treatment plan, Trinity Dental Arts",
    "width": 1733,
    "height": 907
  },
  "local-planning": {
    "url": "https://media.base44.com/images/public/697e88817b05b4051a928e3f/0624757a3_local-planning.png",
    "alt": "A dental lab model and planning display — Implant planning with care at the Trinity office, Trinity Dental Arts",
    "width": 1734,
    "height": 907
  }
};

export const PAGE_SOCIAL_IMAGE_TOPICS = {
  "/blog/what-are-dental-implants": "implants",
  "/blog/dental-implants-near-me-trinity-fl": "local-planning",
  "/blog/what-is-an-implant-dentist": "education",
  "/blog/all-on-4-dental-implants-explained": "implants",
  "/blog/full-mouth-dental-implants-options": "comparison",
  "/blog/teeth-in-a-day-how-it-works": "implants",
  "/blog/same-day-dental-implants-candidates": "implants",
  "/blog/implant-dentures-snap-in-vs-fixed": "comparison",
  "/all-on-x": "implants",
  "/all-on-4-guide": "implants",
  "/too-old-for-dental-implants": "implants",
  "/cant-chew-missing-teeth": "implants",
  "/same-day-dental-implants-trinity-fl": "implants",
  "/dental-implants-trinity-fl": "implants",
  "/dental-implants-new-port-richey-fl": "implants",
  "/all-on-4-trinity-fl": "implants",
  "/all-on-4-new-port-richey-fl": "implants",
  "/all-on-4-vs-dentures": "comparison",
  "/fixed-vs-removable-implant-teeth": "comparison",
  "/dental-implants-vs-dentures": "comparison",
  "/loose-dentures-trinity-fl": "comparison",
  "/all-on-4-vs-all-on-6": "arch-options",
  "/dental-implants-questions": "education",
  "/implant-research-data": "education",
  "/best-implant-dentist-trinity-fl": "education",
  "/cosmetic-dentistry-guide": "cosmetic",
  "/cosmetic-dentist-trinity-fl": "cosmetic",
  "/veneers-trinity-fl": "cosmetic",
  "/cosmetic-dentist-tampa-fl": "cosmetic",
  "/veneers-palm-harbor-fl": "cosmetic",
  "/consult": "consult",
  "/thank-you": "consult",
  "/book-appointment": "consult",
  "/dental-implant-cost-florida": "investment",
  "/does-medicare-cover-dental-implants": "investment",
  "/do-dental-implants-hurt": "comfort",
  "/afraid-of-dental-work-sedation": "comfort",
  "/how-to-choose-a-dentist-in-trinity-fl": "routine",
  "/family-dentist-trinity-fl": "routine",
  "/trinity-fl": "routine",
  "/sleep-apnea-treatment": "sleep",
  "/tmj-treatment": "tmj",
  "/emergency-dentist-trinity-fl": "urgent",
  "/emergency-dentist-new-port-richey-fl": "urgent",
  "/emergency-dentist-clearwater-fl": "urgent",
  "/teeth-whitening-trinity-fl": "whitening",
  "/invisalign-new-port-richey-fl": "aligners",
  "/invisalign-trinity-fl": "aligners",
  "/tampa-fl": "local-planning",
  "/clearwater-fl": "local-planning",
  "/new-port-richey-fl": "local-planning",
  "/dentist-seven-springs-fl": "local-planning",
  "/st-petersburg-fl": "local-planning",
  "/palm-harbor-fl": "local-planning",
  "/dental-implants-near-trinity-college-fl": "local-planning",
  "/dental-implants-near-trinity-commons-fl": "local-planning",
  "/dental-implants-trinity-east-fl": "local-planning",
  "/dental-implants-trinity-west-fl": "local-planning",
  "/dental-implants-trinity-preserve-fl": "local-planning",
  "/spring-hill-fl": "local-planning",
  "/hudson-fl": "local-planning",
  "/brooksville-fl": "local-planning",
  "/holiday-fl": "local-planning",
  "/tarpon-springs-fl": "local-planning",
  "/dunedin-fl": "local-planning",
  "/zephyrhills-fl": "local-planning",
  "/port-richey-fl": "local-planning",
  "/odessa-fl": "local-planning",
  "/keystone-fl": "local-planning",
  "/wesley-chapel-fl": "local-planning",
  "/land-o-lakes-fl": "local-planning",
  "/lutz-fl": "local-planning",
  "/westchase-fl": "local-planning",
  "/oldsmar-fl": "local-planning"
};

export function getPageSocialImage(path) {
  const normalized = (path || '/').split(/[?#]/)[0].replace(/\/+$/, '') || '/';
  return SOCIAL_IMAGE_ASSETS[PAGE_SOCIAL_IMAGE_TOPICS[normalized]] || null;
}
